import type { NonCancellableOrderOffer } from '@fourthwall/services/dist/models/order'

type Reason = NonCancellableOrderOffer['nonCancellableReason']

export const getNonCancellableReason = (reason: Reason) => {
  const map: Record<Reason, string> = {
    CANCELLATION_EXPIRED: 'Cancellation expired',
    IN_DELIVERY: 'Already in delivery',
    DIGITAL_ITEM: 'Digital item',
    DIGITAL_ITEM_DOWNLOADED: 'Digital item downloaded',
    IN_PRODUCTION: 'Already in production',
    ORDER_NOT_CANCELLABLE: 'Not cancellable',
    GIFT_CARD_ALREADY_USED: 'Gift card already used',
    GIFT_CARD_IN_CREATION: 'Gift card in creation',
  }

  return map[reason]
}
